module.exports = __webpack_public_path__ + "assets/41c153731d26c1921e73349423d319b4.png";